import { CalendarDays, CalendarRange, Clock, MapPin, Navigation } from "lucide-react";
import { T } from "@/i18n";

const MAP_QUERY = "Marthoma Camp Centre, National Highway 207, Devanahalli, Bangalore, Karnataka 562110";

export const Details = ({ lang }) => {
  const cards = [
    { key: "dates", icon: CalendarDays, label: T.details.dates[lang], value: T.details.datesVal[lang], highlight: true },
    { key: "days", icon: CalendarRange, label: T.details.days[lang], value: T.details.daysVal[lang] },
    { key: "time", icon: Clock, label: T.details.time[lang], value: T.details.timeVal[lang] },
    { key: "venue", icon: MapPin, label: T.details.venue[lang], value: T.details.venueVal[lang] },
  ];
  return (
    <section id="details" data-testid="details-section" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <p data-testid="details-sub" className={`text-center text-sm uppercase tracking-[0.3em] text-[#FFE500] ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
          {T.details.sub[lang]}
        </p>
        <h2 data-testid="details-heading" className={`mt-3 text-center font-display text-4xl font-bold uppercase text-white sm:text-5xl ${lang === "kn" ? "font-kn normal-case" : ""}`}>
          {T.details.heading[lang]}
        </h2>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((c, i) => (
            <div key={c.key} data-testid={`detail-card-${c.key}`} className={`gc-card-sheen gc-fade-up gc-stagger-${i + 1} rounded-2xl p-6`}>
              <c.icon className={`h-7 w-7 ${c.highlight ? "text-[#FFE500]" : "text-[#FFE500]/70"}`} />
              <p className="mt-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#FFE500]">{c.label}</p>
              <p className={`mt-2 text-base font-medium leading-relaxed text-white/90 ${lang === "kn" ? "font-kn" : ""}`}>{c.value}</p>
            </div>
          ))}
        </div>
        <div className="mt-10 grid items-stretch gap-5 md:grid-cols-2">
          <div data-testid="venue-info-card" className="gc-card-sheen flex flex-col justify-between rounded-2xl p-7">
            <div>
              <MapPin className="h-7 w-7 text-[#FFE500]" />
              <p className="mt-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#FFE500]">{T.details.venue[lang]}</p>
              <p className={`mt-3 font-display text-xl font-bold uppercase tracking-wide text-white ${lang === "kn" ? "font-kn normal-case" : ""}`}>
                Marthoma Camp Centre
              </p>
              <p className={`mt-2 text-sm leading-relaxed text-white/70 ${lang === "kn" ? "font-kn" : ""}`}>
                National Highway 207, Devanahalli,<br />Bangalore, Karnataka – 562110
              </p>
            </div>
            <a
              data-testid="directions-link"
              href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(MAP_QUERY)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex w-fit items-center gap-2 rounded-full border border-[#FFE500]/40 px-6 py-2.5 text-sm font-semibold text-[#FFE500] transition-colors hover:bg-[#FFE500] hover:text-[#0B1233]"
            >
              <Navigation className="h-4 w-4" /> {T.details.directions[lang]}
            </a>
          </div>
          <div className="overflow-hidden rounded-2xl border border-white/10">
            <iframe
              data-testid="venue-map"
              title="Venue map — Marthoma Camp Centre, Devanahalli"
              src={`https://www.google.com/maps?q=${encodeURIComponent(MAP_QUERY)}&output=embed`}
              className="h-72 w-full md:h-full md:min-h-[340px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
